import React from 'react';
import Icon from '../../../components/AppIcon';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const CustomerRetentionCard = ({ data }) => {
  const COLORS = {
    new: 'var(--color-accent)',
    returning: 'var(--color-primary)',
    loyal: 'var(--color-success)'
  };

  const chartData = [
    { name: 'New Customers', value: data?.newCustomers, color: COLORS?.new },
    { name: 'Returning Customers', value: data?.returningCustomers, color: COLORS?.returning },
    { name: 'Loyal Customers', value: data?.loyalCustomers, color: COLORS?.loyal }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg shadow-warm p-3">
          <p className="font-caption text-sm font-semibold mb-1">{payload?.[0]?.name}</p>
          <p className="text-sm data-text" style={{ color: payload?.[0]?.payload?.color }}>
            {payload?.[0]?.value} customers ({((payload?.[0]?.value / data?.totalCustomers) * 100)?.toFixed(1)}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
          Customer Retention
        </h3>
        <div className="flex items-center gap-2 px-3 py-1.5 bg-success/10 rounded-lg">
          <Icon name="TrendingUp" size={16} color="var(--color-success)" />
          <span className="text-sm font-semibold text-success data-text">
            {data?.retentionRate}%
          </span>
        </div>
      </div>
      <div className="w-full h-48 md:h-64 mb-6" aria-label="Customer Retention Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              paddingAngle={5}
              dataKey="value"
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              iconType="circle"
              wrapperStyle={{ fontSize: '12px' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="text-center p-3 bg-accent/10 rounded-lg">
          <p className="text-2xl md:text-3xl font-heading font-bold data-text" style={{ color: COLORS?.new }}>
            {data?.newCustomers}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground font-caption mt-1">New Customers</p>
        </div>
        <div className="text-center p-3 bg-primary/10 rounded-lg">
          <p className="text-2xl md:text-3xl font-heading font-bold data-text" style={{ color: COLORS?.returning }}>
            {data?.returningCustomers}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground font-caption mt-1">Returning</p>
        </div>
        <div className="text-center p-3 bg-success/10 rounded-lg">
          <p className="text-2xl md:text-3xl font-heading font-bold data-text" style={{ color: COLORS?.loyal }}>
            {data?.loyalCustomers}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground font-caption mt-1">Loyal Customers</p>
        </div>
      </div>
    </div>
  );
};

export default CustomerRetentionCard;